import { createClient } from '@supabase/supabase-js';
import { BillingCycle } from '../utils/billingCycleUtils';

// Environment variables for Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://cjwuilcrohkeykyzxdol.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNqd3VpbGNyb2hrZXlreXp4ZG9sIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NDI5MzQyMCwiZXhwIjoyMDY5ODY5NDIwfQ.Ni1zzOzmUlYR9Codb_KcD2--TkpVrM0w--r2Ii7RF7I';

// Debug logging
console.log('🔧 Environment variables check:');
console.log('REACT_APP_SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL ? '✅ SET' : '❌ NOT SET');
console.log('REACT_APP_SUPABASE_ANON_KEY:', process.env.REACT_APP_SUPABASE_ANON_KEY ? '✅ SET' : '❌ NOT SET');
console.log('Using supabaseUrl:', supabaseUrl);
console.log('Using supabaseAnonKey:', supabaseAnonKey ? '✅ SET' : '❌ NOT SET');

// Check if environment variables are set
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables');
  console.error('Please ensure your .env file contains:');
  console.error('REACT_APP_SUPABASE_URL=your_supabase_url');
  console.error('REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key');
  console.error('💡 Try restarting the development server with: npm start');
  throw new Error('Missing Supabase environment variables. Please check your .env file and restart the development server.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Subscription {
  id: string;
  user_id: string;
  name: string;
  cost: number;
  currency?: string; // Make currency optional for backward compatibility
  billing_cycle: BillingCycle;
  payment_method: string;
  start_date: string;
  next_renewal_date: string;
  notes?: string;
  category: string;
  is_shared: boolean;
  shared_with?: string[];
  is_trial: boolean;
  trial_end_date?: string;
  tags: string[];
  is_active?: boolean; // Add active status
  created_at: string;
  updated_at: string;
}

export interface UserPreferences {
  id: string;
  user_id: string;
  main_currency: string;
  email_notifications: boolean;
  whatsapp_notifications: boolean;
  reminder_days_before: number;
  theme_mode: 'light' | 'dark';
  created_at: string;
  updated_at: string;
}

export interface PaymentMethod {
  id: string;
  user_id: string;
  name: string;
  type: 'credit_card' | 'debit_card' | 'paypal' | 'bank_transfer' | 'e_wallet' | 'other';
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  avatar_url?: string;
  created_at: string;
}

export interface Reminder {
  id: string;
  subscription_id: string;
  user_id: string;
  reminder_date: string;
  type: 'email' | 'push' | 'whatsapp';
  sent: boolean;
  created_at: string;
} 